import { render, staticRenderFns } from "./kdbanon.vue?vue&type=template&id=525e46a6&"
import script from "./kdbanon.vue?vue&type=script&lang=js&"
export * from "./kdbanon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports